import { http } from 'services'
import env from 'constants/env'

function firstErrorMessage (value) {
  if (Array.isArray(value)) {
    const message = value.find((item) => item)
    return message ? String(message) : ''
  }
  if (typeof value === 'string') return value
  return ''
}

function normalizeReservationErrors (source) {
  const data = (source && source.response && source.response.data) || (source && source.data) || source || {}
  let bag = null
  if (data.errors && typeof data.errors === 'object' && !Array.isArray(data.errors) && Object.keys(data.errors).length) {
    bag = data.errors
  } else if (data.error_mapper && data.error_mapper[2] && typeof data.error_mapper[2] === 'object' && !Array.isArray(data.error_mapper[2]) && Object.keys(data.error_mapper[2]).length) {
    bag = data.error_mapper[2]
  } else if (data.message && typeof data.message === 'object' && !Array.isArray(data.message)) {
    bag = data.message
  }

  const normalized = {}
  if (bag) {
    Object.keys(bag).forEach((key) => {
      const message = firstErrorMessage(bag[key])
      if (message) normalized[key] = [message]
    })
  }
  if (!Object.keys(normalized).length) {
    const message = firstErrorMessage(data.message) || (data.error_mapper && firstErrorMessage(data.error_mapper[0])) || 'Unable to add parking'
    normalized._form = [String(message)]
  }
  return normalized
}

// initial state
const state = () => ({
  costs: {},
  location: {
    extra_fields:[]
  },
  protectionPlans: [],
  errors: null,
  reservationData: {loading: false, errors: null, added: false},
  loading: false
})

// getters
const getters = {
}

// actions
const actions = {

  ['affiliateWidget.cost'] ({ commit, state }, params) {
    commit('CLEAR_ERRORS')

    return (http.post('public-cost', params)).then((costs) => {
      commit('SET_PUBLIC_COSTS', costs);
    }).catch ((res) => {
      commit('COSTS_ERROR', res);
    });
  },

  ['affiliateWidget.setReservationData'] ({ commit, state }, params) {
    commit('SET_RESERVATION_DATA_ERRORS', null);
    commit('SET_RESERVATION_DATA_LOADING', true);
    const newParams = {
      ...params, 
      costs_token: state.costs.costs_token,
    }
    return (http.post('set-reservation-data', newParams)).then((res) => {
      if(res.data && res.data.error){
        commit('SET_RESERVATION_DATA_ERRORS', normalizeReservationErrors(res.data));
        commit('SET_RESERVATION_DATA_LOADING', false);
        return;
      }
      commit('SET_RESERVATION_DATA_LOADING', false);
      commit('SET_RESERVATION_DATA_ADDED', true);
    }).catch ((res) => {
      commit('SET_RESERVATION_DATA_ERRORS', normalizeReservationErrors(res));
      commit('SET_RESERVATION_DATA_LOADING', false);
    });
  },

  ['affiliateWidget.getLocations']({ dispatch, commit }, params) {
    commit('SET_LOADING', true);
    return fetch(`${env.default.ospUrl}v3/airports/${params.airport_code}/locations-by-airport-code`, {
      method: "GET",
    })
      .then(res => {
        if (!res.ok) {
          return res.json().then(err => { throw err });
        }
        return res.json();
      })
      .then(async (data) => {
        const costPromises = data.data.filter(item => item.reslab_id)
        .map(item => http.post('public-cost', { ...params, location_id: item.reslab_id, protection_plan_id: null })
          .catch(err => {
                return null;
          })
        );
      
        const costsData = await Promise.all(costPromises);
        const costs = costsData
          .filter(c => c !== null && c.data && !c.data.error)
          .map(item => item.data)
          .filter(cost => {
            const reservation = cost && cost.reservation;
            const costLocation = cost && cost.location;
            if (!reservation || !costLocation || costLocation.id == null) return false;
            if (reservation.sold_out) return false;
            const price = Number(reservation.total_after_cancellation_policy);
            return Number.isFinite(price) && price > 0;
          })
          .sort((a, b) => {
            return a.reservation.total_after_cancellation_policy - b.reservation.total_after_cancellation_policy;
          });

        let selected = null;
        let location = null;
        for (let i = 0; i < costs.length; i++) {
          const match = data.data.find(item => Number(item.reslab_id) === Number(costs[i].location.id));
          if (!match) continue;
          selected = costs[i];
          location = match;
          break;
        }

        if (selected && location) {
          const extraFields = selected.location.extra_fields && selected.location.extra_fields.data;
          location.extra_fields = extraFields || [];
          location.photos = (location.photos || []).filter((item) => !item.featured && !item.logo);
          commit('SET_PUBLIC_COSTS', { data: selected });
          commit('SET_ACTIVE_LOCATION', location);
          commit('SET_LOADING', false);
        } else {
          commit('SET_PUBLIC_COSTS', null);
          commit('SET_ACTIVE_LOCATION', null);
          commit('SET_LOADING', false);
          const failed = costsData.find(c => c && c.data && c.data.error && c.data.error_mapper);
          commit('SET_RESERVATION_DATA_ERRORS', failed ? normalizeReservationErrors(failed.data) : null);
        }
      })
      .catch(err => {
        console.log("error", err);
        commit('SET_LOADING', false);
      });
  },
}

// mutations
const mutations = {
  COSTS_ERROR (state, err) {
    try {
      state.errors = err.response.data;
    } catch (e) {
      state.errors = err;
    }
  },

  CLEAR_ERRORS (state) {
    state.errors = null
  },

  SET_PUBLIC_COSTS (state, res) {
    if (res){
      state.costs = res.data;
      if(res.data && res.data.has_vehicle_protection && res.data.location && res.data.location.use_vehicle_protection){
        state.protectionPlans = res.data.protection_plans || [];
      } else {
        state.protectionPlans = [];
      }
    }
  },

  SET_ACTIVE_LOCATION (state, res){
    if (res)
      state.location = res;
  },

  SET_LOADING(state, value){
    state.loading = value;
  },

  SET_RESERVATION_DATA_LOADING(state, res){
    state.reservationData.loading = res;
  },

  SET_RESERVATION_DATA_ADDED(state, res){
    state.reservationData.added = res;
  },

  SET_RESERVATION_DATA_ERRORS(state, res){
    state.reservationData.errors = res;
  },

  CLEAR_RESERVATION_DATA_FIELD_ERROR (state, fieldName) {
    if (!state.reservationData.errors || !fieldName) return
    const err = state.reservationData.errors
    if (typeof err !== 'object' || Array.isArray(err) || !err[fieldName]) return
    const next = { ...err }
    delete next[fieldName]
    state.reservationData.errors = Object.keys(next).length ? next : null
  },

  SET_PROTECTION_PLANS(state, res){
    state.protectionPlans = res;
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}
